import { User } from '@project44/ui-utils';

import { Exception } from '../../../abstract/domain/Exception';

export class UnauthorizedAccessException extends Exception {
  constructor(
    public readonly permissions: Array<string>,
    public readonly user: User,
  ) {
    super(
      `User ${user.id} does not have permissions: ${permissions.toString()}'`,
    );
  }

  public static throw(permissions: Array<string>, user: User): never {
    throw new UnauthorizedAccessException(permissions, user);
  }
}

export class UnknownPropertyException extends Exception {
  constructor(public readonly unknownProperties: Array<string>) {
    super(
      `Cannot access object with unknown properties: ${unknownProperties.toString()}'`,
    );
  }

  public static throw(unknownProperties: Array<string>): never {
    throw new UnknownPropertyException(unknownProperties);
  }
}
